import { writable, get } from 'svelte/store';
import find from 'lodash/find';
import { loadCategories, loadSubCategories } from '../api/category.api';
export default class CategoryService {
    constructor(dataProvider) {
        this._processingCategories = writable(false);
        this._errorCategories = writable(false);
        this._categrories = writable([]);
        this._processingSubCategories = writable(false);
        this._errorSubCategories = writable(false);
        this._subCategrories = writable([]);
        this._category = writable(null);
        this._subCategory = writable(null);
        this._dataProvider = dataProvider;
    }
    loadCategories() {
        this._processingCategories.set(true);
        loadCategories(this._dataProvider.servicesGroupId, this._dataProvider.structureGroupId, this._dataProvider.vocabularyGroupId)
            .then((response) => {
            this._categrories.set(response);
            this._errorCategories.set(false);
        })
            .catch(() => this._errorCategories.set(true))
            .finally(() => this._processingCategories.set(false));
    }
    loadSubCategories(categoryId = null) {
        this._processingSubCategories.set(true);
        loadSubCategories(categoryId, this._dataProvider.servicesGroupId, this._dataProvider.structureGroupId, this._dataProvider.vocabularyGroupId)
            .then((response) => {
            this._subCategrories.set(response);
            this._errorSubCategories.set(false);
        })
            .catch(() => this._errorSubCategories.set(true))
            .finally(() => this._processingSubCategories.set(false));
    }
    prepareCategoryById(categoryId) {
        return this._category.set(find(get(this._categrories), (category) => category.id == categoryId) || null);
    }
    prepareSubCategoryById(subCategoryId) {
        return this._subCategory.set(find(get(this._subCategrories), (category) => category.id == subCategoryId) || null);
    }
    getCategoryById(categoryId) {
        return find(get(this._categrories), (category) => category.id == categoryId) || null;
    }
    getSubCategoryById(subCategoryId) {
        return find(get(this._subCategrories), (category) => category.id == subCategoryId) || null;
    }
    get processingCategoriesSubs() {
        return this._processingCategories;
    }
    get errorCategoriesSubs() {
        return this._errorCategories;
    }
    get categoriesSubs() {
        return this._categrories;
    }
    get processingSubCategoriesSubs() {
        return this._processingSubCategories;
    }
    get errorSubCategoriesSubs() {
        return this._errorSubCategories;
    }
    get subCategoriesSubs() {
        return this._subCategrories;
    }
    get categorySubs() {
        return this._category;
    }
    get subCategorySubs() {
        return this._subCategory;
    }
}
